/**
 * add-order 缺库存拒单（`##11##`）里的商品名单（多版本菜单 B6 U-B6-2 review 第 2 轮 G2）。纯函数，没有 import。
 *
 * 后端的形状：`AddOrderForm.php:756` `addError('itemList', '…##11##' . VarDumper::dumpAsString(Json::encode($zeroStock)) . '##')`，
 * 再由 `DefaultController::actionAddOrder` 的 `commonFormResponse(…, VarDumper::dumpAsString($model->errors))` 包一层 ⇒
 * 名单 JSON（`[{venueProductId, name}]`）被 `addslashes` 了两遍、外面套着一对单引号（真实样本：`tests/unit/fixtures/b6-stock11/add-order-11.json`，
 * 用后端自己的 VarDumper / Json 生成）。
 *
 * 以前的读法是「所有反斜杠一删、去掉外面的单引号、JSON.parse」：商品名里带 `"`（`12" Pizza`）删完就不是 JSON 了，`JSON.parse` 抛错 ——
 * 拦截器在处理一个后端明确的拒单时抛了，调用方拿到的是 `SyntaxError`，被当成「不知道下没下成」。
 *
 * 现在依次试，第一种读得出就用：
 * 1. 按后端的转义层数还原（PHP `stripslashes` 两遍，再一遍）、去掉外面的单引号、`JSON.parse`；
 * 2. 以前的读法（老后端如果少包了一层也读得出）；
 * 3. 在删掉反斜杠的串上按 `{"venueProductId":"…","name":"…"}` 逐个认（名字里带 `"` 也认得出，名字是对象里最后一个键）。
 * 都不行 ⇒ null（调用方改弹今天的通用提示）。
 */

/** PHP `stripslashes`：`\x` ⇒ `x`（`\0` ⇒ NUL，结尾落单的反斜杠去掉） */
function stripSlashes(text) {
  return text.replace(/\\([\s\S]?)/g, (match, next) => (next === '0' ? '\u0000' : next))
}

/** 去掉外面的一对单引号（VarDumper 给字符串套的） */
function unquote(text) {
  const trimmed = text.trim()
  return trimmed.length >= 2 && trimmed[0] === '\'' && trimmed[trimmed.length - 1] === '\'' ? trimmed.slice(1, -1) : trimmed
}

const isId = (value) => (typeof value === 'string' && value !== '') || typeof value === 'number'

/** JSON 读得出、是数组、每一项都带 venueProductId ⇒ 原样的名单；否则 null */
function parsedList(json) {
  let list
  try {
    list = JSON.parse(json)
  } catch (e) {
    return null
  }
  if (!Array.isArray(list)) return null
  return list.every(item => item && typeof item === 'object' && isId(item.venueProductId)) ? list : null
}

/** 以前的读法（一字不改搬过来）：所有反斜杠删掉、去掉外面的单引号 */
function legacyJson(segment) {
  return segment.replace(/\\/g, '').replace('\'[', '[').replace(']\'', ']')
}

const PAIR = /\{"venueProductId":"([^"]+)","name":"([\s\S]*?)"\}/g

/** 逐个认 `{"venueProductId":"…","name":"…"}`（在删掉反斜杠的串上） */
function pairsOf(segment) {
  const text = segment.replace(/\\/g, '')
  const list = []
  let match
  PAIR.lastIndex = 0
  while ((match = PAIR.exec(text)) !== null) list.push({ venueProductId: match[1], name: match[2] })
  return list.length ? list : null
}

/**
 * @param {String} segment `error.info.split('##')[2]`（`##11##` 与结尾 `##` 之间那一段）
 * @returns {Array<{venueProductId: String|Number, name: *}>|null} 读不出 ⇒ null
 */
export function stockShortageProducts(segment) {
  if (typeof segment !== 'string' || !segment) return null
  const once = stripSlashes(segment)
  return parsedList(unquote(stripSlashes(once))) ||
    parsedList(unquote(once)) ||
    parsedList(legacyJson(segment)) ||
    pairsOf(segment)
}
